export default [
    {
        text: 'Nombre',
        value: 'name',
    },
    {
        text: 'alias',
        value: 'firstUPC',
    },
    {
        text: 'UPC',
        value: 'alias_name',
    },
    {
        text: 'COD Interno',
        value: 'internal_code',
    },
    {
        text: 'precio',
        value: 'officePrice',
        format: 'currency',
        align: 'right',
    },
    {
        text: 'costo',
        value: 'officeCostPrice',
        format: 'currency',
        align: 'right',
    },
    {
        text: 'neto',
        value: 'officeNetPrice',
        format: 'currency',
        align: 'right',
    },
    {
        text: 'margen',
        value: 'officeMargin',
        align: 'right',
    },
    {
        text: 'nuevo precio ',
        value: 'newPrice',
		format: 'currency',
        align: 'right',
    },
    {
        text: 'nuevo neto',
        value: 'newNetPrice',
		format: 'currency',
        align: 'right',
    },
    {
        text: 'nuevo margen',
        value: 'newMargin',
        align: 'right',
        input: {
            type: 'float-field',
            reverse: true,
        },
    },
]
